/**
 * Created by JasonChou on 16/4/28.
 */
require('./libs/core.js');
require('./libs/jsBridge.js');
import {router} from './router.js';
import Vue from 'vue';
import VueResource from 'vue-resource';

const FastClick = require('./libs/fastclick.js');
FastClick.attach(document.body);

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css'


Vue.use(VueResource);

import './filters/dateFormat';
import './filters/parseCity';
import './filters/commentNickname';

import wxBugFixer from './services/wxBugFixer';

import RootView from './App.vue';

router.go = function (path) {
  refreshCache[path.name] = true;

  this.__proto__.go.call(this, path);
};
router.start(RootView, 'app');

agent.isWechat && wxBugFixer.fixAndroidPaySafeUrlBug();

wsdk.changeRefresh(false);

Vue.directive('dom', {
  update: function (value) {
    //console.log(this.params.scrollHeight); // -> "hi"
    if (this.vm.doms == null)
      this.vm.doms = {};
    this.vm.doms[value] = this.el;
  }
});



// WEBPACK FOOTER //
// ./src/main.js